import React from 'react';
import { Paper, Stack, Typography, Divider, TextField, InputAdornment } from '@mui/material';
import { Error, CheckCircle } from '@mui/icons-material';
import {Operator} from "../../../classes/Operator";

function OperatorReadinessStatusPanel(props: {
    operatorData: Operator,
    sx?: object
}) {

    const isReady = props.operatorData.readiness!.numberOutstandingRequirements === 0 && props.operatorData.readiness!.numberActiveProblems === 0;

    return (
        <Paper sx={props.sx}>
            <Stack direction="column" spacing={1} padding={2}>
                <Typography variant="h5">Readiness Status</Typography>
                <Divider />
                <Stack direction="row" spacing={1}>
                    <TextField
                        sx={{ width: '33%' }}
                        InputProps={{
                            readOnly: true,
                            startAdornment: (
                                <InputAdornment position="start">
                                    {isReady ? (<CheckCircle color="success" />) : (<Error color="error" />)}
                                </InputAdornment>
                            ),
                        }}
                        label="Current Status"
                        value={isReady ? "Ready" : "Not Ready"}
                    />
                    <TextField
                        sx={{ width: '33%' }}
                        InputProps={{ readOnly: true }}
                        label="Active Problems"
                        value={props.operatorData.readiness!.numberActiveProblems}
                    />
                    <TextField
                        sx={{ width: '33%' }}
                        InputProps={{ readOnly: true }}
                        label="Outstanding Requirements"
                        value={props.operatorData.readiness!.numberOutstandingRequirements}
                    />
                </Stack>
            </Stack>
        </Paper>
    );
}

export default OperatorReadinessStatusPanel;